import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { THEMES } from '../../Shared/models/theme.config';
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private document = inject<Document>(DOCUMENT);

  setTheme(theme = THEMES['default']) {
    // const theme = THEMES[name]; //Theme['green']
    if (theme) {
      Object.keys(theme)?.forEach((key) => {
        try {
          this.document.documentElement.style?.setProperty(`--${key}`, theme[key]);
        } catch (e) { }
      });
    }
  }
}
